/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoomAvailabilityResult } from './RoomAvailabilityResult';
import {
    RoomAvailabilityResultFromJSON,
    RoomAvailabilityResultFromJSONTyped,
    RoomAvailabilityResultToJSON,
    RoomAvailabilityResultToJSONTyped,
} from './RoomAvailabilityResult';

/**
 * 
 * @export
 * @interface RoomAvailabilityResponse
 */
export interface RoomAvailabilityResponse {
    /**
     * 
     * @type {Array<RoomAvailabilityResult>}
     * @memberof RoomAvailabilityResponse
     */
    results: Array<RoomAvailabilityResult>;
}

/**
 * Check if a given object implements the RoomAvailabilityResponse interface.
 */
export function instanceOfRoomAvailabilityResponse(value: object): value is RoomAvailabilityResponse {
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function RoomAvailabilityResponseFromJSON(json: any): RoomAvailabilityResponse {
    return RoomAvailabilityResponseFromJSONTyped(json, false);
}

export function RoomAvailabilityResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoomAvailabilityResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(RoomAvailabilityResultFromJSON)),
    };
}

export function RoomAvailabilityResponseToJSON(json: any): RoomAvailabilityResponse {
    return RoomAvailabilityResponseToJSONTyped(json, false);
}

export function RoomAvailabilityResponseToJSONTyped(value?: RoomAvailabilityResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'results': ((value['results'] as Array<any>).map(RoomAvailabilityResultToJSON)),
    };
}

